import { upvote as apiUpvote, downvote as apiDownvote, removeVote as apiRemoveVote, } from '@wix/ambassador-comments-v1-vote/http';
import { withDevTools } from '../../utils/with-dev-tools';
import { fromServerVote } from './vote-service-mappers';
import { assertFields } from '../../../ts-utils';
import { wrapServiceWithResult } from '../../utils/wrap-service-with-result';
export function createVotesService({ httpClient, errorHandler, getDevState, onError, }) {
    const service = {
        upvote: upvote(httpClient, errorHandler),
        downvote: downvote(httpClient, errorHandler),
        removeVote: removeVote(httpClient, errorHandler),
    };
    return wrapServiceWithResult(withDevTools(service, getDevState), {
        errorEffect: onError,
    });
}
const upvote = (httpClient, errorHandler) => async (payload) => {
    const { withErrorHandler, getResolvedError } = errorHandler;
    try {
        const { data } = await withErrorHandler(() => httpClient.request(apiUpvote(payload)), {
            errorCodesMap: {},
        });
        assertFields(data, ['vote'], 'apiUpvote response');
        return fromServerVote(data.vote);
    }
    catch (error) {
        getResolvedError(error);
        throw error;
    }
};
const downvote = (httpClient, errorHandler) => async (payload) => {
    const { withErrorHandler, getResolvedError } = errorHandler;
    try {
        const { data } = await withErrorHandler(() => httpClient.request(apiDownvote(payload)), {
            errorCodesMap: {},
        });
        assertFields(data, ['vote'], 'apiDownvote response');
        return fromServerVote(data.vote);
    }
    catch (error) {
        getResolvedError(error);
        throw error;
    }
};
const removeVote = (httpClient, errorHandler) => async (payload) => {
    const { withErrorHandler, getResolvedError } = errorHandler;
    try {
        const { data } = await withErrorHandler(() => httpClient.request(apiRemoveVote(payload)), {
            errorCodesMap: {},
        });
        assertFields(data, ['vote'], 'apiRemoveVote response');
        return fromServerVote(data.vote);
    }
    catch (error) {
        getResolvedError(error);
        throw error;
    }
};
//# sourceMappingURL=create-votes-service.js.map